/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountFilter {
    getFixupPrototypeFunction() { return ServiceAccountFilter.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountFilter>): ServiceAccountFilter {
        let obj = Object.assign(new ServiceAccountFilter(), model);
        ServiceAccountFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountFilter>): ServiceAccountFilter {
        if (!model) return null;
        return ServiceAccountFilter.newInstance(<ServiceAccountFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountFilter) {
        if (!obj) return;

        models.ServiceAccountFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountFilter): boolean {
        Object.setPrototypeOf(obj, ServiceAccountFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.sync_status) {
            models.ServiceAccountSync.fixupPrototype(this.sync_status);
        }
        if (this.native_details) {
            for (let val of this.native_details) {
                models.ServiceAccountNativeDetailsBase.fixupPrototype(val);
            }
        }
        if (this.credentials) {
            for (let val of this.credentials) {
                models.ServiceAccountCredentialsBase.fixupPrototype(val);
            }
        }
        if (this.custom_tags) {
            for (let val of this.custom_tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Regular expression to match against the name
     */
    name: string;

    /**
     * If set, includes accounts that have any descendant whose name matches the given name expression.
     */
    name_matches_any_descendants: boolean = false;

    /**
     * Free-text search terms (e.g. comma-separated values from a single search box). An account matches when any term is a case-insensitive substring of any of its identity fields: name, source account id, and the provider native details for Azure (CSP/EA/MCA partner, customer, subscription, department, billing profile, invoice section, enrollment), AWS (account, organization unit), GCP (project, folder, organization, billing account) and OCI (tenancy). Terms do not target a specific field.
     */
    search_text: Array<string>;

    /**
     * Scope of the account.
     */
    scope: models.ServiceAccountScope;

    /**
     * Only include accounts from these master accounts.
     */
    master_account_ids: Array<string>;

    /**
     * Only include accounts from active Tenants
     */
    only_active_tenants: boolean;

    /**
     * Only include accounts from these Tenants.
     */
    tenant_ids: Array<string>;

    /**
     * Include accounts directly under these parents.
     */
    parent_ids: Array<string>;

    /**
     * Also include accounts whose ID matches any of the given parent_ids directly, in addition to their descendants.
     */
    include_parents_in_results: boolean = false;

    /**
     * Also include accounts that are in the descendant hierarchy in any of given parent_ids.
     */
    include_children_recursively: boolean = false;

    /**
     * Also include accounts whose billing_account_id matches any of the given parent_ids, or their descendants when include_children_recursively is set.
     */
    include_billing_as_parent: boolean = false;

    /**
     * Also include accounts whose resource_service_account_id matches any of the given parent_ids, or their descendants when include_children_recursively is set.
     */
    include_resource_as_parent: boolean = false;

    /**
     * Also include AWS GovCloud accounts whose commercial_account_id matches any of the given parent_ids, or their descendants when include_children_recursively is set.
     */
    include_commercial_as_parent: boolean = false;

    /**
     * Add to exclude the specified accounts from results; when include_children_recursively is set along with parent_ids, their descendants are also excluded
     */
    exclude_service_account_ids: Array<string>;

    /**
     * Only include accounts with a parent.
     */
    with_parent: boolean;

    /**
     * Only include accounts without a parent.
     */
    without_parent: boolean;

    /**
     * Only include accounts using these currencies.
     */
    currencies: Array<models.Currency>;

    /**
     * Only include accounts with these statuses.
     */
    statuses: Array<models.ServiceAccountStatus>;

    /**
     * Include accounts created by caller that are in draft mode
     */
    include_draft_accounts: boolean;

    /**
     * Include accounts with any of these features onboarded
     */
    onboarded_any: Array<models.ServiceAccountFeature>;

    /**
     * Include accounts with all of these features onboarded
     */
    onboarded_all: Array<models.ServiceAccountFeature>;

    /**
     * If set, onboarded_any and onboarded_all will also check if the features are actives
     */
    skip_inactive_features: boolean;

    /**
     * If set, onboarded_any and onboarded_all will use desired_status instead of status
     */
    check_onboarding: boolean;

    /**
     * If set, onboarded_any and onboarded_all will ignore features in onboarding state
     */
    strict_onboarded: boolean;

    /**
     * Only include accounts in restricted datacenters
     */
    only_restricted_cloud: boolean;

    /**
     * Exclude all accounts in restricted datacenters
     */
    exclude_restricted_cloud: boolean;

    /**
     * Only include accounts with these native types.
     */
    native_details: Array<models.ServiceAccountNativeDetailsBase>;

    /**
     * Only include accounts with these credentials types.
     */
    credentials: Array<models.ServiceAccountCredentialsBase>;

    /**
     * Only include accounts with all these key/value pairs
     */
    custom_tags: Array<models.KeyValuePair>;

    /**
     * Only include accounts with these sync statuses
     */
    sync_status: models.ServiceAccountSync;

    /**
     * Resource service account ID
     */
    resource_service_account_ids: Array<string>;

    /**
     * Only include cluster accounts with these agent statuses.
     */
    cluster_agent_statuses: Array<models.ClusterAgentStatus>;

}
